import * as React from 'react';

function SvgFlagOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeMiterlimit: 10, strokeWidth: 1.6, d: "M4 22V2.968a.385.385 0 01.192-.331C4.568 2.417 5.582 2 7.846 2c3.077 0 6.971 2.308 9.23 2.308a9.593 9.593 0 003.714-.758.096.096 0 01.133.088v10.547a.192.192 0 01-.115.175c-.396.174-1.792.717-3.731.717-2.308 0-6.154-1.538-9.23-1.538-3.078 0-3.847.769-3.847.769" })));
}

export default SvgFlagOutline;
